import React from "react";
import Icon from "../Icon";

const PreviewStack = ({ children, className = "" }) => (
    <div className={`clk-fdive-preview-stack${className ? ` ${className}` : ""}`}>{children}</div>
);

const LiveTrack = ({ className = "", vertical = false, tone = "blue" }) => (
    <span
        className={`clk-fdive-live-track${vertical ? " clk-fdive-live-track--vertical" : ""}${
            className ? ` ${className}` : ""
        }`}
        aria-hidden="true"
    >
        <span className={`clk-fdive-live-packet clk-fdive-live-packet--${tone}`} />
    </span>
);

const LiveCursor = () => <span className="clk-fdive-live-cursor" aria-hidden="true" />;

const LiveSweep = () => <span className="clk-fdive-live-sweep" aria-hidden="true" />;

const TicketRows = ({ rows }) => (
    <div className="clk-fdive-preview clk-fdive-preview--tickets" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack className="clk-fdive-ticket-stack">
                {rows.map((row, index) => (
                    <div
                        key={row.label}
                        className={`clk-fdive-ticket-row${index === 0 ? " clk-fdive-ticket-row--new" : ""}`}
                        style={{ "--clk-fdive-i": index }}
                    >
                        <span className="clk-fdive-ticket-dot" style={{ background: row.dot }} />
                        <span className="clk-fdive-ticket-label">{row.label}</span>
                        <span className="clk-fdive-ticket-meta">{row.meta}</span>
                    </div>
                ))}
            </PreviewStack>
        </div>
    </div>
);

const EmailPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--email" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack>
                <div className="clk-fdive-email-head clk-fdive-anim" style={{ "--clk-fdive-i": 0 }}>
                    <span className="clk-fdive-email-from">support@company.com</span>
                    <span className="clk-fdive-email-subject">Re: Login issue on mobile</span>
                </div>
                <div className="clk-fdive-email-body clk-fdive-anim" style={{ "--clk-fdive-i": 1 }}>
                    <span className="clk-fdive-email-line clk-fdive-email-line--1" />
                    <span className="clk-fdive-email-line clk-fdive-email-line--2" />
                    <span className="clk-fdive-email-line clk-fdive-email-line--3" />
                </div>
                <div className="clk-fdive-email-badge clk-fdive-anim" style={{ "--clk-fdive-i": 2 }}>
                    Ticket #1041
                </div>
            </PreviewStack>
        </div>
    </div>
);

const ConfirmPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--confirm" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack className="clk-fdive-preview-stack--confirm">
                <div className="clk-fdive-confirm-icon clk-fdive-anim-pop" style={{ "--clk-fdive-i": 0 }}>
                    <Icon name="check" size={18} stroke={2.5} />
                    <span className="clk-fdive-confirm-ring" aria-hidden="true" />
                </div>
                <span className="clk-fdive-confirm-kicker clk-fdive-anim" style={{ "--clk-fdive-i": 1 }}>
                    Confirmation sent
                </span>
                <p className="clk-fdive-confirm-title clk-fdive-anim" style={{ "--clk-fdive-i": 2 }}>
                    We received your request
                </p>
                <p className="clk-fdive-confirm-desc clk-fdive-anim" style={{ "--clk-fdive-i": 3 }}>
                    Your message is in the queue and an agent will reply soon.
                </p>
                <div className="clk-fdive-confirm-meta clk-fdive-anim" style={{ "--clk-fdive-i": 4 }}>
                    <span>Ticket #1041</span>
                    <span aria-hidden="true">·</span>
                    <span>Just now</span>
                </div>
                <div className="clk-fdive-confirm-track clk-fdive-anim" style={{ "--clk-fdive-i": 5 }}>
                    Track your request
                    <Icon name="arrow" size={14} />
                </div>
            </PreviewStack>
        </div>
    </div>
);

const ThreadPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--thread" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack className="clk-fdive-thread-stack">
                <div className="clk-fdive-thread-msg" style={{ "--clk-fdive-i": 0 }}>
                    <span>Customer</span>
                    <p>Can you help reset my account access?</p>
                </div>
                <div className="clk-fdive-thread-msg clk-fdive-thread-msg--note" style={{ "--clk-fdive-i": 1 }}>
                    <span>Internal note</span>
                    <p>Escalated to billing team for review.</p>
                </div>
                <div className="clk-fdive-thread-msg clk-fdive-thread-msg--reply" style={{ "--clk-fdive-i": 2 }}>
                    <span>Reply</span>
                    <p>We are looking into this now.</p>
                </div>
            </PreviewStack>
        </div>
    </div>
);

const MergePreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--merge" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack>
                <div className="clk-fdive-merge-stack clk-fdive-anim" style={{ "--clk-fdive-i": 0 }}>
                    <div className="clk-fdive-merge-ticket">
                        <Icon name="ticket" size={15} />
                        <span>#1038</span>
                    </div>
                    <div className="clk-fdive-merge-plus" aria-hidden="true">
                        <Icon name="plus" size={14} />
                    </div>
                    <div className="clk-fdive-merge-ticket">
                        <Icon name="ticket" size={15} />
                        <span>#1039</span>
                    </div>
                </div>
                <LiveTrack className="clk-fdive-merge-track" vertical tone="blue" />
                <div className="clk-fdive-merge-result clk-fdive-anim" style={{ "--clk-fdive-i": 2 }}>
                    <Icon name="check" size={14} stroke={2.5} />
                    <span>#1040 merged</span>
                </div>
            </PreviewStack>
        </div>
    </div>
);

const TeamPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--team" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack>
                {[
                    ["Billing", "12 open"],
                    ["Support", "28 open"],
                    ["Sales", "6 open"],
                ].map(([name, count], index) => (
                    <div key={name} className="clk-fdive-team-row clk-fdive-anim" style={{ "--clk-fdive-i": index }}>
                        <span className="clk-fdive-team-name">{name}</span>
                        <span className="clk-fdive-team-count">{count}</span>
                    </div>
                ))}
            </PreviewStack>
        </div>
    </div>
);

const RolesPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--roles" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack>
                {[
                    ["Admin", "Manage workspace and billing", "#7c3aed"],
                    ["Agent", "Reply, assign, and resolve tickets", "#0087e2"],
                    ["Customer", "Track requests and reply by email", "#10b981"],
                ].map(([role, desc, color], index) => (
                    <div key={role} className="clk-fdive-role-row clk-fdive-anim" style={{ "--clk-fdive-i": index }}>
                        <span className="clk-fdive-role-label">
                            <span className="clk-fdive-role-dot" style={{ background: color }} aria-hidden="true" />
                            {role}
                        </span>
                        <span className="clk-fdive-role-desc">{desc}</span>
                    </div>
                ))}
            </PreviewStack>
        </div>
    </div>
);

const TagsPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--tags" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack>
                <div className="clk-fdive-tag-ticket clk-fdive-anim" style={{ "--clk-fdive-i": 0 }}>
                    <span className="clk-fdive-tag-ticket-id">#1041</span>
                    <span className="clk-fdive-tag-ticket-subject">Billing question</span>
                </div>
                <div className="clk-fdive-tag-group clk-fdive-tag-group--priority clk-fdive-anim" style={{ "--clk-fdive-i": 1 }}>
                    <span className="clk-fdive-tag-label">Priority</span>
                    <div className="clk-fdive-priority-picker">
                        <span className="clk-fdive-tag-chip">High</span>
                        <span className="clk-fdive-tag-chip">Normal</span>
                        <span className="clk-fdive-tag-chip">Low</span>
                    </div>
                </div>
                <div className="clk-fdive-tag-group clk-fdive-anim" style={{ "--clk-fdive-i": 2 }}>
                    <span className="clk-fdive-tag-label">Type</span>
                    <div className="clk-fdive-tag-chips">
                        <span className="clk-fdive-tag-chip clk-fdive-tag-chip--bug">Bug</span>
                        <span className="clk-fdive-tag-chip clk-fdive-tag-chip--billing">Billing</span>
                    </div>
                </div>
                <div className="clk-fdive-tag-group clk-fdive-anim" style={{ "--clk-fdive-i": 3 }}>
                    <span className="clk-fdive-tag-label">Tags</span>
                    <div className="clk-fdive-tag-chips">
                        <span className="clk-fdive-tag-chip">Enterprise</span>
                        <span className="clk-fdive-tag-chip">Follow-up</span>
                    </div>
                </div>
            </PreviewStack>
        </div>
    </div>
);

const FormPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--form" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack>
                <div className="clk-fdive-form-field clk-fdive-anim" style={{ "--clk-fdive-i": 0 }}>
                    <span>Name</span>
                    <div />
                </div>
                <div className="clk-fdive-form-field clk-fdive-anim" style={{ "--clk-fdive-i": 1 }}>
                    <span>Email</span>
                    <div />
                </div>
                <div
                    className="clk-fdive-form-field clk-fdive-form-field--area clk-fdive-anim"
                    style={{ "--clk-fdive-i": 2 }}
                >
                    <span>Message</span>
                    <div>
                        <LiveCursor />
                    </div>
                </div>
                <div className="clk-fdive-form-submit clk-fdive-anim" style={{ "--clk-fdive-i": 3 }}>
                    Submit ticket
                </div>
            </PreviewStack>
        </div>
    </div>
);

const SHIELD_ROWS = [
    { domain: "yourcompany.com", status: "root", label: "Root domain" },
    { domain: "app.yourcompany.com", status: "ok", label: "Verified" },
    { domain: "unknown-site.net", status: "blocked", label: "Blocked" },
];

const ShieldPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--shield" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack className="clk-fdive-shield-stack">
                <div className="clk-fdive-shield-head" style={{ "--clk-fdive-i": 0 }}>
                    <Icon name="shield" size={15} stroke={2} />
                    <span>Domain allowlist</span>
                </div>
                {SHIELD_ROWS.map((row, index) => (
                    <div
                        key={row.domain}
                        className={`clk-fdive-shield-row clk-fdive-shield-row--${row.status}`}
                        style={{ "--clk-fdive-i": index + 1 }}
                    >
                        <span className="clk-fdive-shield-icon">
                            {row.status === "ok" && <Icon name="check" size={12} stroke={2.5} />}
                            {row.status === "blocked" && <Icon name="close" size={12} stroke={2.5} />}
                            {row.status === "root" && <Icon name="link" size={12} stroke={2} />}
                        </span>
                        <div className="clk-fdive-shield-copy">
                            <strong>{row.domain}</strong>
                            <span>{row.label}</span>
                        </div>
                    </div>
                ))}
            </PreviewStack>
        </div>
    </div>
);

const CHART_BARS = [
    { label: "Mon", height: "42%" },
    { label: "Tue", height: "68%" },
    { label: "Wed", height: "55%" },
    { label: "Thu", height: "82%" },
    { label: "Fri", height: "61%" },
];

const ChartPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--chart" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack>
                <div className="clk-fdive-chart-head clk-fdive-anim" style={{ "--clk-fdive-i": 0 }}>
                    <span>Open tickets</span>
                    <strong>128</strong>
                </div>
                <div className="clk-fdive-bars clk-fdive-anim clk-fdive-bars--live" style={{ "--clk-fdive-i": 1 }}>
                    {CHART_BARS.map((bar, index) => (
                        <div key={bar.label} className="clk-fdive-bar-col">
                            <span style={{ height: bar.height, "--clk-fdive-i": index }} />
                            <em>{bar.label}</em>
                        </div>
                    ))}
                    <LiveSweep />
                </div>
            </PreviewStack>
        </div>
    </div>
);

const ReportPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--report" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack>
                {[
                    ["Overview", "CSV"],
                    ["Team activity", "PDF"],
                    ["Time tracking", "CSV"],
                ].map(([label, format], index) => (
                    <div key={label} className="clk-fdive-report-row clk-fdive-anim" style={{ "--clk-fdive-i": index }}>
                        <span>{label}</span>
                        <span className="clk-fdive-report-format">
                            {format}
                            <Icon name="arrow" size={12} />
                        </span>
                    </div>
                ))}
            </PreviewStack>
        </div>
    </div>
);

const DigestPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--digest" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack>
                <div className="clk-fdive-digest-head clk-fdive-anim" style={{ "--clk-fdive-i": 0 }}>
                    Weekly summary
                </div>
                <LiveTrack className="clk-fdive-digest-track" tone="blue" />
                <div className="clk-fdive-digest-stat clk-fdive-anim" style={{ "--clk-fdive-i": 1 }}>
                    <span>Resolved</span>
                    <strong>48</strong>
                </div>
                <div className="clk-fdive-digest-stat clk-fdive-anim" style={{ "--clk-fdive-i": 2 }}>
                    <span>Open</span>
                    <strong>12</strong>
                </div>
            </PreviewStack>
        </div>
    </div>
);

const SyncPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--sync" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack className="clk-fdive-sync-stack">
                <div className="clk-fdive-sync-bridge">
                    <div className="clk-fdive-sync-pane clk-fdive-sync-pane--tick">
                        <Icon name="ticket" size={14} />
                        <span>Ticket #1042</span>
                    </div>
                    <div className="clk-fdive-sync-connector" aria-hidden="true">
                        <span className="clk-fdive-sync-beam clk-fdive-sync-beam--out" />
                        <span className="clk-fdive-sync-beam clk-fdive-sync-beam--in" />
                        <span className="clk-fdive-sync-hub">
                            <Icon name="link" size={11} stroke={2.2} />
                        </span>
                    </div>
                    <div className="clk-fdive-sync-pane clk-fdive-sync-pane--task">
                        <Icon name="calendar" size={14} />
                        <span>Claritask</span>
                    </div>
                </div>
                <div className="clk-fdive-sync-fields">
                    <div className="clk-fdive-sync-field">
                        <span>Status</span>
                        <strong>In progress</strong>
                    </div>
                    <div className="clk-fdive-sync-field">
                        <span>Task title</span>
                        <strong>Review billing</strong>
                    </div>
                </div>
            </PreviewStack>
        </div>
    </div>
);

const API_LINES = [
    { method: "POST", path: "/api/tickets", tone: "post" },
    { method: "GET", path: "/api/tickets/1041", tone: "get" },
    { method: "PATCH", path: "/api/tickets/1041", tone: "patch" },
];

const ApiPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--api" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack>
                <div className="clk-fdive-api-head clk-fdive-anim" style={{ "--clk-fdive-i": 0 }}>
                    Developer API
                </div>
                {API_LINES.map((line, index) => (
                    <div
                        key={line.path + line.method}
                        className="clk-fdive-api-row clk-fdive-anim"
                        style={{ "--clk-fdive-i": index + 1 }}
                    >
                        <span className={`clk-fdive-api-method clk-fdive-api-method--${line.tone}`}>
                            {line.method}
                        </span>
                        <code>
                            {line.path}
                            {index === API_LINES.length - 1 && <LiveCursor />}
                        </code>
                    </div>
                ))}
                <div className="clk-fdive-api-foot clk-fdive-anim" style={{ "--clk-fdive-i": 4 }}>
                    <span className="clk-fdive-api-status">200 OK</span>
                    <span>JSON · 142ms</span>
                </div>
            </PreviewStack>
        </div>
    </div>
);

const EcosystemPreview = () => (
    <div className="clk-fdive-preview clk-fdive-preview--ecosystem" aria-hidden="true">
        <div className="clk-fdive-preview-card">
            <PreviewStack>
                <div className="clk-fdive-eco-head clk-fdive-anim" style={{ "--clk-fdive-i": 0 }}>
                    <span className="clk-fdive-eco-logo">MyDev</span>
                    <span>Connected apps</span>
                </div>
                {[
                    ["log-out", "Sign-in", "One account across apps"],
                    ["card", "Billing", "Plans and invoices"],
                    ["image", "Media library", "Shared file storage"],
                ].map(([icon, title, sub], index) => (
                    <div key={title} className="clk-fdive-eco-row clk-fdive-anim" style={{ "--clk-fdive-i": index + 1 }}>
                        <span className="clk-fdive-eco-icon">
                            <Icon name={icon} size={15} />
                        </span>
                        <div className="clk-fdive-eco-copy">
                            <strong>{title}</strong>
                            <span>{sub}</span>
                        </div>
                    </div>
                ))}
            </PreviewStack>
        </div>
    </div>
);

const DEFAULT_TICKET_ROWS = [
    { dot: "#0087e2", label: "#1041 · Email", meta: "Open" },
    { dot: "#10b981", label: "#1040 · Widget", meta: "Active" },
    { dot: "#6b7280", label: "#1043 · API", meta: "Pending" },
];

const VISUALS = {
    tickets: () => <TicketRows rows={DEFAULT_TICKET_ROWS} />,
    inbox: () => (
        <TicketRows
            rows={[
                { dot: "#0087e2", label: "#1044 · support@co.com", meta: "New" },
                { dot: "#6b7280", label: "#1043 · billing@co.com", meta: "Open" },
                { dot: "#10b981", label: "#1042 · help@co.com", meta: "Active" },
            ]}
        />
    ),
    confirm: ConfirmPreview,
    email: EmailPreview,
    thread: ThreadPreview,
    merge: MergePreview,
    teams: TeamPreview,
    roles: RolesPreview,
    tags: TagsPreview,
    form: FormPreview,
    shield: ShieldPreview,
    dashboard: ChartPreview,
    reports: ReportPreview,
    digest: DigestPreview,
    sync: SyncPreview,
    api: ApiPreview,
    ecosystem: EcosystemPreview,
};

const FeatureDeepDiveVisual = ({ type }) => {
    const Visual = VISUALS[type] || VISUALS.tickets;
    return (
        <div key={type} className="clk-fcat-detail-visual">
            <Visual />
        </div>
    );
};

export default FeatureDeepDiveVisual;
